"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPECIAL_VALUES_ME = void 0;
/** Special value to indicate the id of current user who is making the request. */
exports.SPECIAL_VALUES_ME = "me";
//# sourceMappingURL=BriefcaseOperationParams.js.map